<template>
  <div class="page-wrapper storybook-cnc-checkbox">
    <StorybookTemplate title="CncCheckbox" pathComponent="/shared/elements/global/v1/CncCheckbox.vue" :pathFigma="pathFigma" :propList="propList" :desc="desc" :form.sync="form">
      <CncCheckbox v-bind="form">{{ form.name }}</CncCheckbox>
    </StorybookTemplate>
  </div>
</template>

<script>
export default {
  components: {
    StorybookTemplate: () => import('../../../../components/StorybookTemplate.vue')
  },
  data () {
    return {
      pathFigma: 'https://www.figma.com/file/QGmzH850ARJRAeL8BuBAer/%5BWEB%5D-Shared-Components?node-id=3303%3A37201&mode=dev',
      desc: 'วิธีการใช้ CncCheckbox ใน form สามารถใช้ <CncCheckbox/> แทน <el-checkbox/> ได้เลย จะเปรียบเสมือนตัว Ui ของ el-checkbox แต่จะพิเศษจากตัวเดิมตรงที่สามารถ cuttom icon ได้ ส่วน error การ validate from สามารถ ใส่ได้ที่ prop ของ error message หรือ จะใช้งานแบบเดิม (rules form) ก็ได้',
      propList: [
        { name: 'name', type: 'input', param: 'name', default: '' },
        { name: 'desc', type: 'input', param: 'desc', default: '' },
        { name: 'value', type: 'boolean', required: true },
        { name: 'disabled', type: 'boolean', required: false },
        { name: 'isReadOnly', type: 'boolean', required: false },
        { name: 'isError', type: 'boolean', required: false },
        { name: 'errMessage', type: 'input', param: 'errMessage', default: '' },
        {
          name: 'size',
          type: 'select',
          param: 'size',
          default: 'small',
          option: [
            { label: 'small', name: 'Small' },
            { label: 'medium', name: 'Medium' }
          ]
        },
        {
          name: 'rightIcon',
          type: 'object',
          param: 'rightIcon',
          objectKey: [
            { key: 'name', type: 'input', value: 'info' },
            { key: 'type', value: 'svg', type: 'select', option: ['svg', 'icon'] }
          ]
        },
        { name: 'isIndeterminate', type: 'boolean', required: false }
      ],

      form: {
        value: true,
        name: 'Checkbox',
        disabled: false,
        isReadOnly: false,
        isError: false,
        desc: 'This is a description.',
        size: 'medium',
        rightIcon: { type: 'icon', name: 'info' },
        errMessage: 'This is an error message.',
        isIndeterminate: false
      }
    }
  }
}
</script>
